import FormService from '../../../core/services/FormService';
import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import NotificationService from '../../../core/services/NotificationService';
import { isRequired } from '../../../core/validations';
import BillListService from './BillListService';

class BillPaymentDialogService {
  form = new FormService();
  submit = new FetchService();

  constructor() {
    extendObservable(this, {
      isOpen: false,
    });
    this.form.validations = {
      paidAt: [isRequired],
      paidValue: [isRequired],
    };
  }

  handleOpen = action((bill) => {
    this.form.setInitialValues({
      id: bill.id,
      billId: bill.billId,
      paidAt: bill.dueDate,
      paidValue: bill.total,
      finesValue: 0,
    });
    this.isOpen = true;
  });

  handlePay = action(() => {
    this.form.setSubmitted();
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }
    this.submit
      .fetch({
        method: 'put',
        url: `/bills/${this.form.getValue('id')}/pay`,
        apiVersion: 'v2',
        body: {
          paidAt: this.form.getValue('paidAt'),
          paidValue: this.form.getValue('paidValue'),
          finesValue: this.form.getValue('finesValue'),
        },
      })
      .then(() => {
        if (this.submit.data) {
          NotificationService.addNotification(`Bill ${this.form.getValue('billId')} paid successfully.`, 'success');
          this.isOpen = false;
          BillListService.load();
        }
        if (this.submit.error) {
          NotificationService.addNotification(`Error paying Bill.`, 'error');
        }
      });
  });

  handleCancel = action(() => {
    this.isOpen = false;
  });
}

const billPaymentDialogService = new BillPaymentDialogService();
export default billPaymentDialogService;
